import React, {useEffect, useState} from 'react';

// redux
import { useSelector } from "react-redux";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

const CustomMetric = (props) => {

    const usedTheme = useSelector(selectUsedTheme);

    return (
        <p style={{
            fontSize: 48,
            fontWeight: '500',
            color: '#000000',
            padding:0, margin:0,
            color: usedTheme.TEXT_COLOR
        }}>{props.children}</p>
    );
};

export default CustomMetric;
